import React from 'react';
import { themeToggleMoonIcon, themeToggleSunIcon } from '@chordbaker/design';

interface ThemeToggleIconProps {
  size?: number;
  color?: string;
  isDark?: boolean;
  className?: string;
}

const ThemeToggleIcon: React.FC<ThemeToggleIconProps> = ({
  size = 24,
  color = 'currentColor',
  isDark = false,
  className,
}) => {
  const icon = isDark ? themeToggleMoonIcon : themeToggleSunIcon;
  const element = icon.elements[0] as { d: string; stroke?: string; strokeWidth?: number | string; strokeLinecap?: string; strokeLinejoin?: string };

  return (
    <svg
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill={icon.fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d={element.d}
        stroke={color}
        strokeWidth={element.strokeWidth}
        strokeLinecap={element.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']}
        strokeLinejoin={element.strokeLinejoin as React.SVGAttributes<SVGPathElement>['strokeLinejoin']}
      />
    </svg>
  );
};

export default ThemeToggleIcon;
